import axios from "axios/index";

const baseURL = "https://explorer.ont.io/v2"; // "https://polarisexplorer.ont.io/v2"; // "https://explorer.ont.io/v2"

export default {
  state: {
    summaryinfo: {},
    roundfirstinfo: {},
    currentcycleinfo: 0,
    historycycleinfo: {},
    calculationinfo: {},
    nodeinfo: {},
    userinfo: {},
  },
  getters: {
    summaryinfo: (state) => state.summaryinfo,
    roundfirstinfo: (state) => state.roundfirstinfo,
    currentcycleinfo: (state) => state.currentcycleinfo,
    historycycleinfo: (state) => state.historycycleinfo,
    calculationinfo: (state) => state.calculationinfo,
    nodeinfo: (state) => state.nodeinfo,
    userinfo: (state) => state.userinfo,
  },
  mutations: {
    setsummaryinfo(state, payload) {
      state.summaryinfo = payload;
    },
    setroundfirstinfo(state, payload) {
      state.roundfirstinfo = payload;
    },
    setcurrentcycleinfo(state, payload) {
      state.currentcycleinfo = payload;
    },
    sethistorycycleinfo(state, payload) {
      state.historycycleinfo = payload;
    },
    setcalculationinfo(state, payload) {
      state.calculationinfo = payload;
    },
    setnodeinfo(state, payload) {
      state.nodeinfo = payload;
    },
    setuserinfo(state, payload) {
      state.userinfo = payload;
    },
  },
  actions: {
    async getSummaryInfo({ commit }) {
      let url = baseURL + "/summary/blockchain/latest-info";
      let ret = await axios.get(url);
      commit("setsummaryinfo", ret.data.result);
    },
    async getRoundFirstInfo({ commit }, params) {
      let url =
        "https://dappnode1.ont.io:10334/api/v1/block/details/height/" +
        params.height;
      let ret = await axios.get(url);
      commit("setroundfirstinfo", ret.data.Result.Header);
    },
    async getCurrentCycle({ commit }) {
      let url = baseURL + "/nodes/current-staking-cycle";
      let ret = await axios.get(url);
      commit("setcurrentcycleinfo", ret.data.result);
    },
    async getHistoryCycle({ commit }) {
      let url = baseURL + "/nodes/round-history?page_size=5&page_number=1";
      let ret = await axios.get(url);
      commit("sethistorycycleinfo", ret.data.result);
    },
    async getCalculationInfo({ commit }) {
      let url = baseURL + "/nodes/node-incentives/calculation-info";
      let ret = await axios.get(url);
      commit("setcalculationinfo", ret.data.result);
    },
    async getNodeInfo({ commit }, params) {
      let data = {
        init_pos: params.init_pos,
        node_proportion: params.node_proportion,
        node_type: params.node_type,
      };
      let url = baseURL + "/nodes/node-incentives/calculation";
      let ret = await axios.post(url, data);
      commit("setnodeinfo", ret.data.result);
    },
    async getUserInfo({ commit }, params) {
      let data = {
        public_key: params.public_key,
        stake_amount: params.stake_amount,
      };
      let url = baseURL + "/nodes/user-incentives/calculation";
      let ret = await axios.post(url, data);
      commit("setuserinfo", ret.data.result);
    },
  },
};
